import React, { useEffect, useState } from "react";
import Modal from "../Modal";

export default function PromptModal({
  open,
  title,
  label,
  defaultValue = "",
  placeholder = "",
  helper = "",
  validate,           // (val) => null | string
  confirmLabel = "OK",
  onConfirm,          // (val) => void | Promise
  onClose,
}) {
  const [val, setVal] = useState(defaultValue);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) {
      setVal(defaultValue);
      setErr("");
      setBusy(false);
    }
  }, [open, defaultValue]);

  async function submit() {
    const v = (val || "").trim();
    if (!v) { setErr("required"); return; }
    if (validate) {
      const e = validate(v);
      if (e) { setErr(e); return; }
    }
    try {
      setBusy(true);
      await onConfirm?.(v);
      onClose?.();
    } catch (e) {
      setErr(e?.message || "failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <Modal
      open={open}
      title={title}
      onClose={onClose}
      footer={
        <>
          <button className="ide-button" onClick={onClose}>Cancel</button>
          <button
            className="ide-button-primary"
            disabled={busy}
            onClick={submit}
          >
            {busy ? "Working\u2026" : confirmLabel}
          </button>
        </>
      }
    >
      <label className="block text-xs uppercase tracking-wider text-ide-mute mb-1">
        {label}
      </label>
      <input
        autoFocus
        className="w-full px-2.5 py-1.5 rounded-md border border-ide-border bg-ide-panel2 text-ide-text font-mono text-sm focus-visible:ring-2 focus-visible:ring-ide-accent/60"
        value={val}
        onChange={(e) => setVal(e.target.value)}
        placeholder={placeholder}
        onKeyDown={(e) => { if (e.key === "Enter") submit(); }}
      />
      {helper && <div className="text-[11px] text-ide-mute mt-1.5">{helper}</div>}
      {err && <div className="text-[11px] text-rose-300 mt-1.5">{err}</div>}
    </Modal>
  );
}
